import Component from '../abstracts/Component';
import TrackingComponent from './TrackingComponent';

export default class SocialLoginComponent extends Component {
  constructor(compEl) {
    super();
    this.socialLoginWrapper = compEl;
    this.googleSubmitBtn = compEl.querySelector(this.SELECTORS.googleButton);
    this.facebookSubmitBtn = compEl.querySelector(this.SELECTORS.facebookButton);
    this.appleSubmitBtn = compEl.querySelector(this.SELECTORS.appleButton);
    this.TrackingComponent = new TrackingComponent();
  }

  get COMPONENTNAME() {
    return 'SocialLoginComponent';
  }

  get SELECTORS() {
    return {
      socialLoginWrapper: '.social-login-wrapper',
      googleButton: '.btn-google-submit',
      facebookButton: '.btn-facebook-submit',
      appleButton: '.btn-apple-submit'
    }
  }

  startOauthRedirectFlow() {
    let ctx = this;

    let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
    const country = document.getElementsByTagName('body')[0].dataset.website;
    if (this.googleSubmitBtn) {
      $(this.googleSubmitBtn).closest('form')[0].addEventListener("click", (e) => {
        e.preventDefault();
        let page = $(e.srcElement).closest(".social-login-wrapper")[0].getAttribute('page');
        const source = $(e.srcElement).closest('.social-login-wrapper')[0].getAttribute('source');
        $.ajax({
          method: 'GET',
          url: contextPath + '/action/social-login/login-url/google?email=',
          success: function (data) {
            if (data === 'error') {
              window.location = "/error";
            } else {
              let clientId = data.clientId;
              let redirectUri = data.callbackUri;
              let state = {
                source: source || '',
                type: 'social-login'
              };
              let encodedState = encodeURIComponent(JSON.stringify(state));
              let url = `https://accounts.google.com/o/oauth2/v2/auth?&response_type=code&redirect_uri=${redirectUri}&client_id=${clientId}&scope=openid%20profile%20email&state=${encodedState}`;
              if (page) {
                if (page === 'login') {
                  ctx.TrackingComponent.actions.socialLogin('google');
                } else if (page === 'register') {
                  ctx.TrackingComponent.actions.signupSocial('google', country);
                }
              } else {
                ctx.TrackingComponent.actions.socialAccess('google', country);
              }
              window.location.href = url;
            }
          }
        })
      });
    }

    if (this.facebookSubmitBtn) {
      $(this.facebookSubmitBtn).closest('form')[0].addEventListener("click", (e) => {
        e.preventDefault();
        let page = $(e.srcElement).closest(".social-login-wrapper")[0].getAttribute('page');
        const source = $(e.srcElement).closest('.social-login-wrapper')[0].getAttribute('source');
        $.ajax({
          method: 'GET',
          url: contextPath + '/action/social-login/login-url/facebook?email=',
          success: function (data) {
            if (data === 'error') {
              window.location = "/error";
            } else {
              let clientId = data.clientId;
              let redirectUri = data.callbackUri;
              let state = {
                source: source || '',
                type: 'social-login'
              };
              let encodedState = encodeURIComponent(JSON.stringify(state));
              let url = `https://www.facebook.com/v18.0/dialog/oauth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=public_profile,email&state=${encodedState}`;
              if (page) {
                if (page === 'login') {
                  ctx.TrackingComponent.actions.socialLogin('facebook');
                } else if (page === 'register') {
                  ctx.TrackingComponent.actions.signupSocial('facebook', country);
                }
              } else {
                ctx.TrackingComponent.actions.socialAccess('facebook', country);
              }
              window.location.href = url;
            }
          }
        })
      });
    }

    if (this.appleSubmitBtn) {
      $(this.appleSubmitBtn).closest('form')[0].addEventListener("click", (e) => {
        e.preventDefault();
        let page = $(e.srcElement).closest(".social-login-wrapper")[0].getAttribute('page');
        const source = $(e.srcElement).closest('.social-login-wrapper')[0].getAttribute('source');
        $.ajax({
          method: 'GET',
          url: contextPath + '/action/social-login/login-url/apple?email=',
          success: function (data) {
            if (data === 'error') {
              window.location = "/error";
            } else {
              let clientId = data.clientId;
              let redirectUri = data.callbackUri;
              let state = {
                source: source || '',
                type: 'social-login'
              };
              let encodedState = encodeURIComponent(JSON.stringify(state));
              let url = `https://appleid.apple.com/auth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code%20id_token&response_mode=form_post&scope=name%20email&state=${encodedState}`;
              if (page) {
                if (page === 'login') {
                  ctx.TrackingComponent.actions.socialLogin('apple');
                } else if (page === 'register') {
                  ctx.TrackingComponent.actions.signupSocial('apple', country);
                }
              } else {
                ctx.TrackingComponent.actions.socialAccess('apple', country);
              }
              window.location.href = url;
            }
          }
        })
      });
    }
  }

  render() {
    super.render();
    this.startOauthRedirectFlow();
  }
}
